<template>
    <main-content-marketing>
        <div class="bg-white rounded p-4 shadow-sm">
            <div class="row">
                <div class="col-12 h4 my-2">
                    <i class="fas fa-link"></i>
                    <span class="px-2">{{ $t('marketing.marketing_tools.register_link') }}</span>
                </div>
                <div class="col-12 my-2 pt-2 py-4 border-bottom">
                    <div class="d-flex justify-content-center align-items-center">
                        <input class="form-control text-center" disabled id="register_link" name="register_link"
                               style="width: 300px" type="text">
                        <div class="mx-2">
                            <i @click="copy" class="fa fa-copy" style="font-size:20px; cursor:pointer"
                               title="copy">
                            </i>
                        </div>
                    </div>
                </div>
                <div class="col-12 h4 my-2">
                    <i class="fas fa-image"></i>
                    <span class="px-2">{{ $t('marketing.marketing_tools.banner') }}</span>
                </div>
                <div class="col-12 col-md-6 mt-2 mb-4">
                    <label class="h5">
                        {{ $t('marketing.marketing_tools.horizental_banner') }}
                    </label>
                    <div style="height: 140px">
                        <img :src="marketing_tools.hor_banner" alt="register-link" class="hor_banner">
                    </div>
                    <label>
                        {{ $t('marketing.marketing_tools.using_banner') }}
                    </label>
                    <div>
                        <textarea
                                class="col-12 banner_text_area"
                                dir="ltr"
                                disabled id="html_750">
                        </textarea>
                    </div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label class="h5">
                        {{ $t('marketing.marketing_tools.vertical') }}
                    </label>
                    <div style="height: 140px">
                        <img :src="marketing_tools.ver_banner" alt="register-link" class="ver_banner">
                    </div>
                    <label>
                        {{ $t('marketing.marketing_tools.using_banner') }}
                    </label>
                    <div>
                        <textarea
                                class="col-md-12 col-sm-6 banner_text_area"
                                dir="ltr"
                                disabled id="html_440">
                        </textarea>
                    </div>
                </div>
            </div>
        </div>
    </main-content-marketing>
</template>

<script>
    import $ from 'jquery'
    import {mapGetters} from "vuex";
    import MainContentMarketing from "@/components/main-content-marketing";

    export default {
        name: 'MarketingDashboard',
        components: {
            MainContentMarketing,
        },
        computed: {
            ...mapGetters('marketing', [
                'marketing_tools'
            ])
        },
        async mounted() {
            this.$store.dispatch('marketing/fetchMarketingTools').finally(() => {
                this.afterDispatch()
            })
        },
        methods: {
            afterDispatch() {
                this.loadHtml();
                this.getLink()
            },
            copy() {
                let copiedLink = $('#register_link');
                copiedLink.removeAttr('disabled');
                copiedLink.select();
                document.execCommand("copy");
                copiedLink.attr('disabled', 'disabled');
            },
            loadHtml() {
                $('#html_750').val('<div>' +
                    '<a href=\'' + window.location.origin + '/register/' + this.marketing_tools.referer_id + '\'>' +
                    '<img src=\'' + this.marketing_tools.hor_banner + '\' alt=\'register-link\'>' +
                    '</a>' +
                    '</div>');
                $('#html_440').val('<div>' +
                    '<a href=\'' + window.location.origin + '/register/' + this.marketing_tools.referer_id + '\'>' +
                    '<img src=\'' + this.marketing_tools.ver_banner + '\' alt=\'register-link\' >' +
                    '</a>' +
                    '</div>')
            },
            getLink() {
                $('#register_link').val(window.location.origin + '/register/' + this.marketing_tools.referer_id)
            }
        }

    }
</script>

<style>
    @media screen and (max-width: 1024px) {
        .hor_banner {
            width: 200px;
            height: 60px
        }

        .ver_banner {
            width: 70px;
            height: 90px
        }
    }

    @media screen and (min-width: 1024px) {
        .hor_banner {
            width: 200px;
            height: 60px
        }

        .ver_banner {
            width: 70px;
            height: 90px
        }
    }

    .banner_text_area {
        min-height: 110px
    }

    .line-divider {
        height: 1px;
        background-color: #dee2e6
    }
</style>